import { NotificationDefinition } from './types'
import {
  genericNotificationDefinition,
  integrationSyncErrorDefinition,
  invoiceAutoIssueAccountingLockedDefinition,
  invoiceAutoIssueFailedDefinition,
  invoiceEmailFailedDefinition,
  invoiceTaxErrorDefinition,
  quoteAutoExecuteFailedDefinition,
  quotePdfGenerationFailedDefinition,
  quotePdfGenerationTimeoutDefinition,
  quoteSignatureRequestFailedDefinition,
  quoteStuckInPreparingSignatureRequestStatusDefinition,
  quoteWebhookProcessingFailedDefinition
} from './definitions'

export const notificationDefinitions: Record<string, NotificationDefinition> = {
  GENERIC_AGENT_NOTIFICATION: genericNotificationDefinition,
  INTEGRATION_SYNC_ERROR: integrationSyncErrorDefinition,
  INVOICE_AUTO_ISSUE_ACCOUNTING_LOCKED:
    invoiceAutoIssueAccountingLockedDefinition,
  INVOICE_AUTO_ISSUE_FAILED: invoiceAutoIssueFailedDefinition,
  INVOICE_EMAIL_FAILED: invoiceEmailFailedDefinition,
  INVOICE_TAX_ERROR: invoiceTaxErrorDefinition,
  QUOTE_AUTO_EXECUTE_FAILED: quoteAutoExecuteFailedDefinition,
  QUOTE_DROPBOX_SIGNATURE_REQUEST_REJECTED:
    quoteSignatureRequestFailedDefinition,
  QUOTE_PDF_GENERATION_FAILED: quotePdfGenerationFailedDefinition,
  QUOTE_PDF_GENERATION_TIMEOUT: quotePdfGenerationTimeoutDefinition,
  QUOTE_STUCK_IN_PREPARING_SIGNATURE_REQUEST_STATUS:
    quoteStuckInPreparingSignatureRequestStatusDefinition,
  QUOTE_WEBHOOK_PROCESSING_FAILED: quoteWebhookProcessingFailedDefinition
}
